import { type ComboboxItem, type OptionsFilter, Select, type SelectProps } from "@mantine/core";

type FilterSelectProps = SelectProps;

export function FilterSelect({ ...props }: FilterSelectProps) {
  const optionsFilter: OptionsFilter = ({ options, search }) => {
    const splittedSearch = search.toLowerCase().trim().split(" ");
    return (options as ComboboxItem[]).filter((option) => {
      const words = option.label.toLowerCase().trim().split(" ");
      return splittedSearch.every((searchWord) => words.some((word) => word.includes(searchWord)));
    });
  };

  return <Select {...props} filter={optionsFilter} searchable />;
}
